import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { MDBSpinner } from 'mdb-react-ui-kit';

const PrivateRoute = ({ children, allowedRoles }) => {
  const { user, loading } = useAuth();
  const location = useLocation();
//console.log("User Details In Private = ", user);
  if (loading) return <div className="text-center py-5">
                  <MDBSpinner grow size="lg" />
                  <p className="mt-3">Loading...</p>
                </div>;
  
  //<div>Loading...</div>;
  
  if (!user) {
    return <Navigate to="/Login" state={{ from: location }} replace />;
  }

  if (allowedRoles && !allowedRoles.includes(user.role)) {
    return <Navigate to="/Dashboard" replace />;
  }

  return children;
};

export default PrivateRoute;

/*import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';


const PrivateRoute = ({ children, allowedRoles }) => {
  const { user, loading } = useAuth();

  if (loading) return <div>Loading...</div>;
  if (!user) return <Navigate to="/Login" />;
  if (allowedRoles && !allowedRoles.includes(user.role)) return <Navigate to="/Dashboard" />;

  return children;
};

export default PrivateRoute;
*/